import { Good } from "@/entities/good";
import { GoodVersion } from "@/entities/goodVersion";
import { geniFetch } from "../geniBackend";
import { resolveImageUrl } from "@/utils/imageRef";

// Для Kaspi не используем "published": успех по API не гарантирует реальную публикацию,
// поэтому товар остаётся "На модерации" (moderation/processing) и меняется только при ошибке.
export type KaspiPublishStatus = "processing" | "moderation" | "error";

interface KaspiPublishResponse {
  status: KaspiPublishStatus;
  importCode?: string;
  categoryCode?: string;
  error?: string;
}

/**
 * Публикация товара на Kaspi — вся логика (категория, характеристики, импорт) живёт в
 * geni-backend. Фронт лишь передаёт контент активной версии и полные HTTPS-URL картинок.
 * После успешного запроса товар уходит «На модерацию» (status = "processing").
 */
export const publicateKaspiGoodVersion = async (
  good: Good,
  version: GoodVersion,
): Promise<KaspiPublishResponse> => {
  const rawImages = version.media?.images?.length ? version.media.images : good.images || [];
  const images = rawImages
    .map((img) => resolveImageUrl(img))
    .filter((url) => /^https?:\/\//i.test(url));

  const response = await geniFetch<KaspiPublishResponse>(`/kaspi/goods/${good.id}/publish`, {
    method: "POST",
    body: JSON.stringify({
      title: version.title,
      description: version.description,
      brand: good.brand,
      images,
      characteristics: good.characteristics,
    }),
  });

  // Локально отражаем статус, чтобы UI сразу показал «На модерации».
  good.publishStatus = response?.status === "error" ? "error" : "moderation";
  good.publicationData.kaspi = {
    ...(good.publicationData.kaspi || {}),
    importCode: response?.importCode,
    categoryCode: response?.categoryCode,
    status: response?.status,
  };

  return response;
};
